import { mockDb } from './mockDb';
import {
  generateFeatureToggles,
  generateOrgs,
  generateUsers,
} from './featureToggles/featureToggles.data';
import { generateSelf } from './self/self.data';
import { generateAllCapabilitiesForUser } from './allCapabilitiesForUser/allCapabilitiesForUser.data';
import {
  generateProgressiveDeliveryAuditLog,
  generateProgressiveDeliveryConfigs,
} from './progressiveDelivery/progressiveDelivery.data';

sessionStorage.setItem('mockFeatureToggleViewer', 'true');
sessionStorage.setItem('mockFeatureToggleAdmin', 'true');

export const genMockDbData = async (): Promise<void> => {
  if (sessionStorage.getItem('mock-generated') === 'true') {
    return;
  }

  // Clear stale data from previous session
  await mockDb.delete();
  await mockDb.open();

  const featureToggleCount = 50;

  const users = generateUsers(50);
  const organizations = generateOrgs(50);
  const featureToggles = generateFeatureToggles(
    featureToggleCount,
    users,
    organizations
  );

  const pdConfigs = generateProgressiveDeliveryConfigs(featureToggles);
  const pdAuditLog = generateProgressiveDeliveryAuditLog(pdConfigs);

  const self = generateSelf();
  const allCapabilitiesForUser = generateAllCapabilitiesForUser(self);

  try {
    await Promise.all([
      mockDb.featureToggles.bulkAdd(featureToggles),
      mockDb.users.bulkAdd(users),
      mockDb.organizations.bulkAdd(organizations),
      mockDb.self.add(self),
      mockDb.allCapabilitiesForUser.bulkAdd(allCapabilitiesForUser),
      mockDb.pdConfigs.bulkAdd(pdConfigs),
      mockDb.pdAuditLog.bulkAdd(pdAuditLog),
    ]);
  } catch (error) {
    console.error('mock(init): Unable to generate mock data', error);
    return;
  }

  sessionStorage.setItem('mock-generated', 'true');
};
